import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CompanyProfileSkeleton,
  CompanyProfileAudit,
  AircraftTypeRatingAudit,
  CompanyAddressAudit,
  CustomerDutyAudit,
  DelayTypeAudit,
  DepartmentAudit,
  DutyTimeBufferAudit,
  ExpenseTypeAudit,
  CrewMemberTypeAudit,
  PaymentTypeAudit,
  BusinessCategoryAudit,
  JobGradeAudit,
  StaffEventTypeAudit,
  StaffGroupAudit,
  DutyTimeAllowanceAudit
} from '../+models/company-profile-audit.model';
import { CompanyProfileFacade } from '../+state/company-profile/company-profile.facade';
import { CompanyProfileAuditListComponent } from './company-profile-audit-list/company-profile-audit-list.component';
import { CompanyAddressAuditListComponent } from './company-address-audit-list/company-address-audit-list.component';
import { AircraftTypeRatingAuditListComponent } from './aircraft-type-rating-audit-list/aircraft-type-rating-audit-list.component';
import { CustomerDutyAuditListComponent } from './customer-duty-audit-list/customer-duty-audit-list.component';
import { DelayTypeAuditListComponent } from './delay-type-audit-list/delay-type-audit-list.component';
import { DepartmentAuditListComponent } from './department-audit-list/department-audit-list.component';
import { DutyTimeBufferAuditListComponent } from './duty-time-buffer-audit-list/duty-time-buffer-audit-list.component';
import { ExpenseTypeAuditListComponent } from './expense-type-audit-list/expense-type-audit-list.component';
import { CrewMemberTypeAuditListComponent } from './crew-member-type-audit-list/crew-member-type-audit-list.component';
import { PaymentTypeAuditListComponent } from './payment-type-audit-list/payment-type-audit-list.component';
import { BusinessCategoryAuditListComponent } from './business-category-audit-list/business-category-audit-list.component';
import { JobGradeAuditListComponent } from './job-grade-audit-list/job-grade-audit-list.component';
import { StaffEventTypeAuditListComponent } from './staff-event-type-audit-list/staff-event-type-audit-list.component';
import { StaffGroupAuditListComponent } from './staff-group-audit-list/staff-group-audit-list.component';
import { DutyTimeAllowanceAuditListComponent } from './duty-time-allowance-audit-list/duty-time-allowance-audit-list.component';

@Component({
  selector: 'sd-portal-company-profile-audit',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})
export class CompanyProfileComponent implements OnInit {
  companyProfileSkeletonLoaded$: Observable<boolean>;
  companyProfileSkeletonLoading$: Observable<boolean>;
  companyProfileSkeleton$: Observable<CompanyProfileSkeleton | null | undefined>;

  companyProfileAuditsLoaded$: Observable<boolean>;
  companyProfileAuditsLoading$: Observable<boolean>;
  companyProfileAudits$: Observable<CompanyProfileAudit[]>;

  aircraftTypeRatingAuditsLoaded$: Observable<boolean>;
  aircraftTypeRatingAuditsLoading$: Observable<boolean>;
  aircraftTypeRatingAudits$: Observable<AircraftTypeRatingAudit[]>;

  companyAddressAuditsLoaded$: Observable<boolean>;
  companyAddressAuditsLoading$: Observable<boolean>;
  companyAddressAudits$: Observable<CompanyAddressAudit[]>;

  customerDutyAuditsLoaded$: Observable<boolean>;
  customerDutyAuditsLoading$: Observable<boolean>;
  customerDutyAudits$: Observable<CustomerDutyAudit[]>;

  delayTypeAuditsLoaded$: Observable<boolean>;
  delayTypeAuditsLoading$: Observable<boolean>;
  delayTypeAudits$: Observable<DelayTypeAudit[]>;

  departmentAuditsLoaded$: Observable<boolean>;
  departmentAuditsLoading$: Observable<boolean>;
  departmentAudits$: Observable<DepartmentAudit[]>;

  dutyTimeBufferAuditsLoaded$: Observable<boolean>;
  dutyTimeBufferAuditsLoading$: Observable<boolean>;
  dutyTimeBufferAudits$: Observable<DutyTimeBufferAudit[]>;

  expenseTypeAuditsLoaded$: Observable<boolean>;
  expenseTypeAuditsLoading$: Observable<boolean>;
  expenseTypeAudits$: Observable<ExpenseTypeAudit[]>;

  crewMemberTypeAuditsLoaded$: Observable<boolean>;
  crewMemberTypeAuditsLoading$: Observable<boolean>;
  crewMemberTypeAudits$: Observable<CrewMemberTypeAudit[]>;

  paymentTypeAuditsLoaded$: Observable<boolean>;
  paymentTypeAuditsLoading$: Observable<boolean>;
  paymentTypeAudits$: Observable<PaymentTypeAudit[]>;

  businessCategoryAuditsLoaded$: Observable<boolean>;
  businessCategoryAuditsLoading$: Observable<boolean>;
  businessCategoryAudits$: Observable<BusinessCategoryAudit[]>;

  jobGradeAuditsLoaded$: Observable<boolean>;
  jobGradeAuditsLoading$: Observable<boolean>;
  jobGradeAudits$: Observable<JobGradeAudit[]>;

  staffEventTypeAuditsLoaded$: Observable<boolean>;
  staffEventTypeAuditsLoading$: Observable<boolean>;
  staffEventTypeAudits$: Observable<StaffEventTypeAudit[]>;

  staffGroupAuditsLoaded$: Observable<boolean>;
  staffGroupAuditsLoading$: Observable<boolean>;
  staffGroupAudits$: Observable<StaffGroupAudit[]>;

  dutyTimeAllowanceAuditsLoaded$: Observable<boolean>;
  dutyTimeAllowanceAuditsLoading$: Observable<boolean>;
  dutyTimeAllowanceAudits$: Observable<DutyTimeAllowanceAudit[]>;

  @ViewChildren(CompanyProfileAuditListComponent)
  companyProfileAuditLists: QueryList<CompanyProfileAuditListComponent>;
  @ViewChildren(AircraftTypeRatingAuditListComponent)
  aircraftTypeRatingAuditLists: QueryList<AircraftTypeRatingAuditListComponent>;
  @ViewChildren(CompanyAddressAuditListComponent)
  companyAddressAuditLists: QueryList<CompanyAddressAuditListComponent>;
  @ViewChildren(CustomerDutyAuditListComponent)
  customerDutyAuditLists: QueryList<CustomerDutyAuditListComponent>;
  @ViewChildren(DelayTypeAuditListComponent)
  delayTypeAuditLists: QueryList<DelayTypeAuditListComponent>;
  @ViewChildren(DepartmentAuditListComponent)
  departmentAuditLists: QueryList<DepartmentAuditListComponent>;
  @ViewChildren(DutyTimeBufferAuditListComponent)
  dutyTimeBufferAuditLists: QueryList<DutyTimeBufferAuditListComponent>;
  @ViewChildren(ExpenseTypeAuditListComponent)
  expenseTypeAuditLists: QueryList<ExpenseTypeAuditListComponent>;
  @ViewChildren(CrewMemberTypeAuditListComponent)
  crewMemberTypeAuditLists: QueryList<CrewMemberTypeAuditListComponent>;
  @ViewChildren(PaymentTypeAuditListComponent)
  paymentTypeAuditLists: QueryList<PaymentTypeAuditListComponent>;
  @ViewChildren(BusinessCategoryAuditListComponent)
  businessCategoryAuditLists: QueryList<BusinessCategoryAuditListComponent>;
  @ViewChildren(JobGradeAuditListComponent)
  jobGradeAuditLists: QueryList<JobGradeAuditListComponent>;
  @ViewChildren(StaffEventTypeAuditListComponent)
  staffEventTypeAuditLists: QueryList<StaffEventTypeAuditListComponent>;
  @ViewChildren(StaffGroupAuditListComponent)
  staffGroupAuditLists: QueryList<StaffGroupAuditListComponent>;
  @ViewChildren(DutyTimeAllowanceAuditListComponent)
  dutyTimeAllowanceAuditLists: QueryList<DutyTimeAllowanceAuditListComponent>;

  constructor(private readonly companyProfileFacade: CompanyProfileFacade) {}

  ngOnInit() {
    this.companyProfileSkeletonLoaded$ = this.companyProfileFacade.companyProfileSkeletonLoaded$;
    this.companyProfileSkeletonLoading$ = this.companyProfileFacade.companyProfileSkeletonLoading$;
    this.companyProfileSkeleton$ = this.companyProfileFacade.companyProfileAuditSkeleton$;

    this.companyProfileAuditsLoaded$ = this.companyProfileFacade.companyProfileAuditsLoaded$;
    this.companyProfileAuditsLoading$ = this.companyProfileFacade.companyProfileAuditsLoading$;
    this.companyProfileAudits$ = this.companyProfileFacade.companyProfileAudits$;

    this.aircraftTypeRatingAuditsLoaded$ =
      this.companyProfileFacade.aircraftTypeRatingAuditsLoaded$;
    this.aircraftTypeRatingAuditsLoading$ =
      this.companyProfileFacade.aircraftTypeRatingAuditsLoading$;
    this.aircraftTypeRatingAudits$ = this.companyProfileFacade.aircraftTypeRatingAudits$;

    this.companyAddressAuditsLoaded$ = this.companyProfileFacade.companyAddressAuditsLoaded$;
    this.companyAddressAuditsLoading$ = this.companyProfileFacade.companyAddressAuditsLoading$;
    this.companyAddressAudits$ = this.companyProfileFacade.companyAddressAudits$;

    this.customerDutyAuditsLoaded$ = this.companyProfileFacade.customerDutyAuditsLoaded$;
    this.customerDutyAuditsLoading$ = this.companyProfileFacade.customerDutyAuditsLoading$;
    this.customerDutyAudits$ = this.companyProfileFacade.customerDutyAudits$;

    this.delayTypeAuditsLoaded$ = this.companyProfileFacade.delayTypeAuditsLoaded$;
    this.delayTypeAuditsLoading$ = this.companyProfileFacade.delayTypeAuditsLoading$;
    this.delayTypeAudits$ = this.companyProfileFacade.delayTypeAudits$;

    this.departmentAuditsLoaded$ = this.companyProfileFacade.departmentAuditsLoaded$;
    this.departmentAuditsLoading$ = this.companyProfileFacade.departmentAuditsLoading$;
    this.departmentAudits$ = this.companyProfileFacade.departmentAudits$;

    this.dutyTimeBufferAuditsLoaded$ = this.companyProfileFacade.dutyTimeBufferAuditsLoaded$;
    this.dutyTimeBufferAuditsLoading$ = this.companyProfileFacade.dutyTimeBufferAuditsLoading$;
    this.dutyTimeBufferAudits$ = this.companyProfileFacade.dutyTimeBufferAudits$;

    this.expenseTypeAuditsLoaded$ = this.companyProfileFacade.expenseTypeAuditsLoaded$;
    this.expenseTypeAuditsLoading$ = this.companyProfileFacade.expenseTypeAuditsLoading$;
    this.expenseTypeAudits$ = this.companyProfileFacade.expenseTypeAudits$;

    this.crewMemberTypeAuditsLoaded$ = this.companyProfileFacade.crewMemberTypeAuditsLoaded$;
    this.crewMemberTypeAuditsLoading$ = this.companyProfileFacade.crewMemberTypeAuditsLoading$;
    this.crewMemberTypeAudits$ = this.companyProfileFacade.crewMemberTypeAudits$;

    this.paymentTypeAuditsLoaded$ = this.companyProfileFacade.paymentTypeAuditsLoaded$;
    this.paymentTypeAuditsLoading$ = this.companyProfileFacade.paymentTypeAuditsLoading$;
    this.paymentTypeAudits$ = this.companyProfileFacade.paymentTypeAudits$;

    this.businessCategoryAuditsLoaded$ = this.companyProfileFacade.businessCategoryAuditsLoaded$;
    this.businessCategoryAuditsLoading$ = this.companyProfileFacade.businessCategoryAuditsLoading$;
    this.businessCategoryAudits$ = this.companyProfileFacade.businessCategoryAudits$;

    this.jobGradeAuditsLoaded$ = this.companyProfileFacade.jobGradeAuditsLoaded$;
    this.jobGradeAuditsLoading$ = this.companyProfileFacade.jobGradeAuditsLoading$;
    this.jobGradeAudits$ = this.companyProfileFacade.jobGradeAudits$;

    this.staffEventTypeAuditsLoaded$ = this.companyProfileFacade.staffEventTypeAuditsLoaded$;
    this.staffEventTypeAuditsLoading$ = this.companyProfileFacade.staffEventTypeAuditsLoading$;
    this.staffEventTypeAudits$ = this.companyProfileFacade.staffEventTypeAudits$;

    this.staffGroupAuditsLoaded$ = this.companyProfileFacade.staffGroupAuditsLoaded$;
    this.staffGroupAuditsLoading$ = this.companyProfileFacade.staffGroupAuditsLoading$;
    this.staffGroupAudits$ = this.companyProfileFacade.staffGroupAudits$;

    this.dutyTimeAllowanceAuditsLoaded$ = this.companyProfileFacade.dutyTimeAllowanceAuditsLoaded$;
    this.dutyTimeAllowanceAuditsLoading$ =
      this.companyProfileFacade.dutyTimeAllowanceAuditsLoading$;
    this.dutyTimeAllowanceAudits$ = this.companyProfileFacade.dutyTimeAllowanceAudits$;

    this.companyProfileFacade.loadCompanyProfileAudit();
  }

  loadCompanyProfileAudits(companyProfileId: number) {
    this.companyProfileFacade.loadCompanyProfileAudits(companyProfileId);
  }

  nextCompanyProfileAuditPage(companyProfileId: number) {
    this.companyProfileFacade.nextCompanyProfileAuditPage(companyProfileId);
  }

  companyProfileOpened(companyProfile: CompanyProfileSkeleton) {
    setTimeout(() => {
      const match = this.companyProfileAuditLists.find(
        c => c.companyProfileId === companyProfile.customerId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadAircraftTypeRatingAudits(aircraftTypeRatingId: number) {
    this.companyProfileFacade.loadAircraftTypeRatingAudits(aircraftTypeRatingId);
  }

  nextAircraftTypeRatingAuditPage(aircraftTypeRatingId: number) {
    this.companyProfileFacade.nextAircraftTypeRatingAuditPage(aircraftTypeRatingId);
  }

  aircraftTypeRatingOpened(aircraftTypeRatingId: number) {
    setTimeout(() => {
      const match = this.aircraftTypeRatingAuditLists.find(
        a => a.aircraftTypeRatingId === aircraftTypeRatingId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadCompanyAddressAudits(companyAddressId: number) {
    this.companyProfileFacade.loadCompanyAddressAudits(companyAddressId);
  }

  nextCompanyAddressAuditPage(companyAddressId: number) {
    this.companyProfileFacade.nextCompanyAddressAuditPage(companyAddressId);
  }

  companyAddressOpened(companyAddressId: number) {
    setTimeout(() => {
      const match = this.companyAddressAuditLists.find(
        c => c.companyAddressId === companyAddressId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadCustomerDutyAudits(customerDutyId: number) {
    this.companyProfileFacade.loadCustomerDutyAudits(customerDutyId);
  }

  nextCustomerDutyAuditPage(customerDutyId: number) {
    this.companyProfileFacade.nextCustomerDutyAuditPage(customerDutyId);
  }

  customerDutyOpened(customerDutyId: number) {
    setTimeout(() => {
      const match = this.customerDutyAuditLists.find(c => c.customerDutyId === customerDutyId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadDelayTypeAudits(delayTypeId: number) {
    this.companyProfileFacade.loadDelayTypeAudits(delayTypeId);
  }

  nextDelayTypeAuditPage(delayTypeId: number) {
    this.companyProfileFacade.nextDelayTypeAuditPage(delayTypeId);
  }

  delayTypeOpened(delayTypeId: number) {
    setTimeout(() => {
      const match = this.delayTypeAuditLists.find(c => c.delayTypeId === delayTypeId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadDepartmentAudits(departmentId: number) {
    this.companyProfileFacade.loadDepartmentAudits(departmentId);
  }

  nextDepartmentAuditPage(departmentId: number) {
    this.companyProfileFacade.nextDepartmentAuditPage(departmentId);
  }

  departmentOpened(departmentId: number) {
    setTimeout(() => {
      const match = this.departmentAuditLists.find(c => c.departmentId === departmentId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadDutyTimeBufferAudits(dutyTimeBufferId: number) {
    this.companyProfileFacade.loadDutyTimeBufferAudits(dutyTimeBufferId);
  }

  nextDutyTimeBufferAuditPage(dutyTimeBufferId: number) {
    this.companyProfileFacade.nextDutyTimeBufferAuditPage(dutyTimeBufferId);
  }

  dutyTimeBufferOpened(dutyTimeBufferId: number) {
    setTimeout(() => {
      const match = this.dutyTimeBufferAuditLists.find(
        c => c.dutyTimeBufferId === dutyTimeBufferId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadDutyTimeAllowanceAudits(dutyTimeAllowanceId: number) {
    this.companyProfileFacade.loadDutyTimeAllowanceAudits(dutyTimeAllowanceId);
  }

  nextDutyTimeAllowanceAuditPage(dutyTimeAllowanceId: number) {
    this.companyProfileFacade.nextDutyTimeAllowanceAuditPage(dutyTimeAllowanceId);
  }

  dutyTimeAllowanceOpened(dutyTimeAllowanceId: number) {
    setTimeout(() => {
      const match = this.dutyTimeAllowanceAuditLists.find(
        c => c.dutyTimeAllowanceId === dutyTimeAllowanceId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadExpenseTypeAudits(expenseTypeId: number) {
    this.companyProfileFacade.loadExpenseTypeAudits(expenseTypeId);
  }

  nextExpenseTypeAuditPage(expenseTypeId: number) {
    this.companyProfileFacade.nextExpenseTypeAuditPage(expenseTypeId);
  }

  expenseTypeOpened(expenseTypeId: number) {
    setTimeout(() => {
      const match = this.expenseTypeAuditLists.find(c => c.expenseTypeId === expenseTypeId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadCrewMemberTypeAudits(crewMemberTypeId: number) {
    this.companyProfileFacade.loadCrewMemberTypeAudits(crewMemberTypeId);
  }

  nextCrewMemberTypeAuditPage(crewMemberTypeId: number) {
    this.companyProfileFacade.nextCrewMemberTypeAuditPage(crewMemberTypeId);
  }

  crewMemberTypeOpened(crewMemberTypeId: number) {
    setTimeout(() => {
      const match = this.crewMemberTypeAuditLists.find(
        c => c.crewMemberTypeId === crewMemberTypeId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadPaymentTypeAudits(paymentTypeId: number) {
    this.companyProfileFacade.loadPaymentTypeAudits(paymentTypeId);
  }

  nextPaymentTypeAuditPage(paymentTypeId: number) {
    this.companyProfileFacade.nextPaymentTypeAuditPage(paymentTypeId);
  }

  paymentTypeOpened(paymentTypeId: number) {
    setTimeout(() => {
      const match = this.paymentTypeAuditLists.find(c => c.paymentTypeId === paymentTypeId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadBusinessCategoryAudits(businessCategoryId: number) {
    this.companyProfileFacade.loadBusinessCategoryAudits(businessCategoryId);
  }

  nextBusinessCategoryAuditPage(businessCategoryId: number) {
    this.companyProfileFacade.nextBusinessCategoryAuditPage(businessCategoryId);
  }

  businessCategoryOpened(businessCategoryId: number) {
    setTimeout(() => {
      const match = this.businessCategoryAuditLists.find(
        c => c.businessCategoryId === businessCategoryId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadJobGradeAudits(jobGradeId: number) {
    this.companyProfileFacade.loadJobGradeAudits(jobGradeId);
  }

  nextJobGradeAuditPage(jobGradeId: number) {
    this.companyProfileFacade.nextJobGradeAuditPage(jobGradeId);
  }

  jobGradeOpened(jobGradeId: number) {
    setTimeout(() => {
      const match = this.jobGradeAuditLists.find(c => c.jobGradeId === jobGradeId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadStaffEventTypeAudits(staffEventTypeId: number) {
    this.companyProfileFacade.loadStaffEventTypeAudits(staffEventTypeId);
  }

  nextStaffEventTypeAuditPage(staffEventTypeId: number) {
    this.companyProfileFacade.nextStaffEventTypeAuditPage(staffEventTypeId);
  }

  staffEventTypeOpened(staffEventTypeId: number) {
    setTimeout(() => {
      const match = this.staffEventTypeAuditLists.find(
        c => c.staffEventTypeId === staffEventTypeId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadStaffGroupAudits(staffGroupId: number) {
    this.companyProfileFacade.loadStaffGroupAudits(staffGroupId);
  }

  nextStaffGroupAuditPage(staffGroupId: number) {
    this.companyProfileFacade.nextStaffGroupAuditPage(staffGroupId);
  }

  staffGroupOpened(staffGroupId: number) {
    setTimeout(() => {
      const match = this.staffGroupAuditLists.find(c => c.staffGroupId === staffGroupId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }
}
